"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COINS = void 0;
/* eslint-disable global-require */
exports.COINS = {
    ada: require('../../../images/coins/ada.svg'),
    bch: require('../../../images/coins/bch.svg'),
    btc: require('../../../images/coins/btc.svg'),
    test: require('../../../images/coins/btctestnet.svg'),
    btg: require('../../../images/coins/btg.svg'),
    dash: require('../../../images/coins/dash.svg'),
    dgb: require('../../../images/coins/dgb.svg'),
    doge: require('../../../images/coins/doge.svg'),
    etc: require('../../../images/coins/etc.svg'),
    eth: require('../../../images/coins/eth.svg'),
    owc: require('../../../images/coins/owc.svg'),
    owdt: require('../../../images/coins/owdt.svg'),
    ltc: require('../../../images/coins/ltc.svg'),
    nmc: require('../../../images/coins/nmc.svg'),
    trop: require('../../../images/coins/trop.svg'),
    txrp: require('../../../images/coins/txrp.svg'),
    vtc: require('../../../images/coins/vtc.svg'),
    xrp: require('../../../images/coins/xrp.svg'),
    zec: require('../../../images/coins/zec.svg'),
};
